<!-- 小程序推广链接页 回传设置侧边栏 -->
<template>
<!-- 回传比例相关侧边栏 -->
<a-drawer
  title="编辑回传设置"
  width="1000px"
  placement="right"
  :closable="false"
  :visible="hc_visible"
  @close="hcCloseDrawer"
>
	<div v-if="h_type_pl == 0" class="form-cell-box">
		<div class="class-title">推广名称</div>
			
		<div style="font-size: 15px;">{{h_name}}</div>
	</div>
	
	<div v-if="h_type_pl == 0" class="form-cell-box">
		<div class="class-title">推广链接ID</div>
			
		<div style="font-size: 15px;">{{h_id}}</div>
	</div>
	
	<div v-if="h_type_pl == 1" class="form-cell-box" style="align-items: self-start;">
		<div class="class-title">已选的推广名称</div>
			
		<div>
			<div style="max-height: 240px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 11px;display: flex;align-items: center;margin-right: 10px;" class="">
					<!-- <div style="width: 70px;text-align: right;">{{item.plan_id}}</div>
					<span style="margin: 0 5px;"> — </span> -->
					<div style="">{{item.name || '空'}}、 </div>
				</div>
			</div>
		</div>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title">推广平台</div>
			
		<div style="font-size: 15px;">{{h_channel_name}}</div>
	</div>
	<div style="padding: 20px;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;">
		<div style="font-weight: 600;margin-bottom: 15px;">推广链接层回传参数</div>
		
		<div class="form-cell-box">
			<div class="class-title">设置方式</div>
			<div>
				<a-radio-group @change="hcRadioE" name="radioGroup" :value="h_report_per_type">
					<a-radio :value="1">
					  固定回传序列（老版本）
					</a-radio>
					<a-radio :value="2">
					  自定义回传序列
					</a-radio>
				  </a-radio-group>
			</div>
		</div>
		
		<template v-if="h_report_per_type == 2">
			<div class="form-cell-box" style="align-items: flex-start;">
				<div class="class-title">自定义回传序列</div>
				<div class="custom-report-drawer-box" style="flex: 1;">
					<div v-for="(itmm,indd) in hCustomData" :key="itmm.id" style="border: 1px solid #ccc;border-radius: 8px;padding: 30px 20px;margin-bottom: 15px;position: relative;">
						<div style="display: flex;align-items: center;margin-bottom: 25px;">
							<span>订单金额范围：</span>
							<div style="display: flex;align-items: center;">
								<a-input-number v-model="itmm.h_min_money" :min="0" :max="1000" />
								<span style="margin: 0 10px;">到</span>
								<a-input-number v-model="itmm.h_max_money" :min="0" :max="1000" />
								<span style="margin-left: 10px;">元</span>
								<span style="margin-left: 15px;color: #8d8b8b;">说明：包含左右金额</span>
							</div>
						</div>
						
						<div style="margin-bottom: 12px;display: flex;">
							<div style="margin-bottom: 5px;text-align: right;">注册当日首充订单：</div>
							<span style="width: 90px;"> 序列长度：{{itmm.h_order_per.length}} </span>
							<div @click="hcCustomHandleA(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								添加
							</div>
							<div @click="hcCustomHandleC(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								删除
							</div>
						</div>
						<div style="margin-bottom: 12px;display: flex;">
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in itmm.h_order_per" :key="item.id">
									<a-popover placement="top" :getPopupContainer="getsPopupContainer">
										<template slot="content">
										  <span @click="hcCustomDelA(index,indd)" style="cursor: pointer;font-size: 12px;color: #1890ff;">删除</span>
										</template>
										<a-input-number v-model="item.value" size="small" style="width: 25px;margin-right: 10px;margin-bottom: 7px;" :min="0" :max="1" />
									 </a-popover>
								</div>
							</div>
						</div>
						
						<a-icon @click="hcDelCustom(indd)" style="font-size: 16px;position: absolute;right: 15px;top: 15px;cursor: pointer;color: rgba(0, 0, 0, 0.65);" type="close" />
					</div>
					
					<a-button @click="hcAddCustom" icon="plus" >新增订单范围</a-button>
				</div>
			</div>
		</template>
		
		<template v-else-if="h_report_per_type == 1">
			<div class="form-cell-box">
				<div class="class-title">回传最低金额</div>
					
				<a-input-number @change='hcNumber($event,1)' :min="0" :max="100000" :value="h_report_money_limit" style="width: 130px;" />
				<span style="margin-left: 10px;">元</span>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">注册时间</div>
				
				<div>
					<a-radio-group @change="hcRadioA" name="radioGroup" :value="h_user_reg_time_condition">
						<a-radio :value="1">
						  只传注册当天用户
						</a-radio>
						<a-radio :value="0">
						  注册时间不限
						</a-radio>
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">充值时间</div>
					
				<div>
					<a-radio-group @change="hcRadioB" name="radioGroup" :value="h_order_time_condition_type" style="width: 100%;">
						<a-radio :value="1">
							注册日期当天首次充值
						</a-radio>
						<a-radio :value="0" style="width: 260px;">
							<div style="display: inline-block;align-items: center;">
								注册后
								<a-input-number @change='hcNumber($event,2)' :min="0" :max="100000" :value="h_order_time_condition_n" style="width: 80px;margin: 0 5px;" />
								小时内首次充值
							</div>
						  
						</a-radio>
						
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">回传比例</div>
					
				<a-input-number @change='hcNumber($event,3)' :min="0" :max="100000" :value="h_report_per"  style="width: 130px;" />
			</div>
			
			<div class="form-cell-box" style="margin-bottom: 20px;margin-top: 20px;">
				<div class="class-title">回传事件类型</div>
				<div v-if="h_channel_name.indexOf('腾讯') > -1">
					<a-radio-group @change="hcRadioL" name="radioGroup" :value="h_report_type">
						<a-radio :value="1">
						  下单(ORDER_COMPLETE)
						</a-radio>
						<a-radio :value="2">
						  付费(PURCHASE)
						</a-radio>
					</a-radio-group>
				</div>
				
				<div v-else-if="h_channel_name.indexOf('巨量') > -1">
					<a-radio-group name="radioGroup" :value="1">
						<a-radio :value="1">
						  付费(active_pay)
						</a-radio>
					</a-radio-group>
				</div>
				
				<div v-else-if="h_channel_name.indexOf('百度') > -1">
					<a-radio-group name="radioGroup" :value="1">
						<a-radio :value="1">
						  短剧付费观看(118)
						</a-radio>
					</a-radio-group>
				</div>
				
				<div v-else-if="h_channel_name.indexOf('微博') > -1">
					<a-radio-group name="radioGroup" :value="1">
						<a-radio :value="1">
						  微信付费字段(action_type=6)
						</a-radio>
					</a-radio-group>
				</div>
			</div>
			
			<div v-if="h_report_type == 2" class="form-cell-box">
				<div class="class-title">是否全量回传</div>
				<div>
					<a-radio-group @change="hcRadioF" name="radioGroup" :value="h_report_all">
						<a-radio :value="1">
						  全量
						</a-radio>
						<a-radio :value="0">
						  不全量
						</a-radio>
					</a-radio-group>
					<span style="margin-left: 15px;color: #8d8b8b;">说明：用于回传腾讯时，告知腾讯是否为全量回传。</span>
				</div>
			</div>
			
			<div v-if="h_channel_name.indexOf('腾讯') > -1" class="form-cell-box" style="margin-bottom: 20px;margin-top: 20px;">
				<div class="class-title">补充事件类型</div>
				<div>
					<a-checkbox-group v-model="h_report_other_type" :options="['关键页面访问','在线咨询','关键行为']" @change="hcChangeA" />
				</div>
			</div>
		</template>
		
		<div class="form-cell-box">
			<div class="class-title">是否启用回传设置</div> 
				
			<a-switch @change="hcDrawerSwitch" :checked="h_status" checked-children="启用" un-checked-children="暂停" />
		</div>
	</div>
	
	<div style="color: red;height: 23px;margin-top: 35px;margin-bottom: -10px;margin-left: 40px;">{{hc_form_hint}}</div>
	
	<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
		<a-button @click="hcRequest" :loading="hc_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
		<a-button @click="hcCloseDrawer">取消</a-button>
	</div>

</a-drawer>
</template>

<script>
export default {
	name: 'hcSetDrawer_',
	components: {
	},
	data() {
		return {
			// 回传比例侧边栏
			hc_visible: false, // 侧边栏是否显示
			hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
			hc_form_hint: "",
			
			h_name: "", // 名称，仅用于展示，不用于请求
			h_id: "", // ID
			h_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
			h_user_reg_time_condition: 1, // 注册时间
			h_order_time_condition_type: 1, // 充值时间
			h_order_time_condition_n: 24, // 注册后几小时内首次充值
			h_report_per: 100, // 回传比例
			h_status: true, // 是否启用-回传侧边栏
			h_channel: undefined,
			
			h_report_type: 1, // 事件类型 1下单时间，2付费事件
			h_report_other_type: [], // 1=关键页面访问，2=在线咨询，3=关键行为
			h_report_all: 1, // 是否全量回传 0=否，1=是
			
			// 自定义回传
			h_report_per_type: 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			hCustomData: [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
				}
			],
			
			h_channel_name: "", // 推广平台
			h_type_pl: 0, // 0表示单个设置，1表示批量设置
		}
	},
	mounted(){
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 计划回传比例侧边栏开始
		setPlanHcbl(e){
			this.h_channel = e.channel
			this.h_name = e.name
			this.h_id = e.link_id
			this.h_channel_name = e.channel_name
			let ee = e.config
			if(e.config){
				this.h_report_money_limit = ee.report_money_limit, // 回传最低金额
				this.h_user_reg_time_condition = ee.user_reg_time_condition, // 注册时间
				this.h_order_time_condition_type = ee.order_time_condition_type, // 充值时间
				this.h_order_time_condition_n = ee.order_time_condition_n, // 注册后几小时内首次充值
				this.h_report_per = ee.report_per // 回传比例
				
				if(this.h_channel_name.indexOf('腾讯') > -1){
					this.h_report_type = ee.report_type || 1 // 默认值为1表示下单事件
					this.h_report_all = ee.report_all // 是否全量回传 0=否，1=是
					// 补充事件类型
					if(ee.report_other_type){
						let o_arr = []
						ee.report_other_type.forEach(res=>{
							if(res == 1){
								o_arr.push('关键页面访问')
							}
							else if(res == 2){
								o_arr.push('在线咨询')
							}
							else if(res == 3){
								o_arr.push('关键行为')
							}
						})
						this.h_report_other_type = o_arr
					}
					else {
						this.h_report_other_type = []
					}
				}
				
				// 自定义回传部分
				this.h_report_per_type = ee.report_per_type // 回传类型
				if(ee.report_per_type == 2){ // 自定义回传
					if(ee.report_per_self){
						let h_data = []
						let e_data = ee.report_per_self
						e_data.forEach((res,index)=>{
							let obj = {
								id: 'c' + index.toString() + new Date().getTime(),
								h_min_money: res.min_money, // 金额区间最小金额
								h_max_money: res.max_money, // 金额区间最大金额
							}
							
							let aaa = []
							res.order_per.forEach((res_a,index_a)=>{
								let ooo = {
									id: 'a' + index_a.toString() + new Date().getTime(), // 因为会有删除操作，所以要有id，避免删除之后会乱
									value: res_a
								}
								aaa.push(ooo)
							})
							obj.h_order_per = aaa
							
							h_data.push(obj)
						})
						this.hCustomData = h_data
					}
				}
				
				if(ee.status == 1){ // 启用
					this.h_status = true // 是否启用-回传侧边栏
				}
				else {
					this.h_status = false
				}
				
			}
			this.h_type_pl = 0
			this.hc_visible = true
		},
		// 回传比例确认按钮
		hcRequest(){
			let that = this
			
			let r_data = {
				report_per_type: that.h_report_per_type, // 1=老回传比率，2=自定义回传比率
			}
			
			const hc_p = new Promise((resolve,reject)=>{
				if(that.h_report_per_type == 2){ // 自定义回传
					let rrr = []
					let check_control = true
					for(let i = 0;i < that.hCustomData.length; i++){
						let res = JSON.parse(JSON.stringify(that.hCustomData[i]))
						let index = Number(JSON.parse(JSON.stringify(i)))
						// 规则校验。有几种情况。1后面的订单金额必须要大于前面的订单金额。
						// 2.订单金额范围之间不能冲突，覆盖的范围不能相同
						if(res.h_max_money < res.h_min_money){
							that.$message.warning('金额范围配置错误。第二个数值要大于等于第一个数值');
							check_control = false
							break;
						}
						// 第二点 校验。订单金额范围之间不能有冲突
						for(let z = 0;z < that.hCustomData.length; z++){
							let z_es = JSON.parse(JSON.stringify(that.hCustomData[z]))
							// 把每一个订单范围的金额的第一个值，跟全部的范围进行对比，如果在范围内则不能请求
							if( i != z && res.h_min_money >= z_es.h_min_money && res.h_min_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
							else if( i != z && res.h_max_money >= z_es.h_min_money && res.h_max_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
						}
						
						
						let obj = {
							min_money: res.h_min_money,
							max_money: res.h_max_money,
						}
						let aaa = []
						res.h_order_per.forEach(res_a=>{
							aaa.push(res_a.value)
						})
						obj.order_per = aaa
						
						rrr.push(obj)
					}
					
					console.log("check_control",check_control)
					if(check_control){ // true表示校验成功
						console.log("check_control",'校验成功')
						resolve('校验成功')
					}
					else {
						console.log("check_control",'校验失败')
						reject('校验失败')
					}
					r_data.report_per_self = rrr
					
				}
				else { // 固定列回传
					resolve('校验成功')
				}
			})
			
			// 先校验完，在进行接下来的操作
			hc_p.then(value=>{ // promise状态-成功。表示校验成功，继续进行下一步
				
				that.hc_button_loading = true
				
				// 老版回传。都带上
				r_data.report_money_limit = that.h_report_money_limit, // 回传最低金额
				r_data.user_reg_time_condition = that.h_user_reg_time_condition, // 注册时间
				r_data.order_time_condition_type = that.h_order_time_condition_type, // 充值时间
				r_data.report_per = that.h_report_per // 回传比例
				// report_per: that.h_report_per.toString() // 回传比例。旧版有转化成字符串的操作，忘记原因。
				
				if(that.h_channel_name.indexOf('腾讯') > -1){
					r_data.report_type = that.h_report_type // 事件类型
					r_data.report_all = that.h_report_all // 是否全量回传 0=否，1=是
					if(that.h_report_other_type.length > 0){
						let sj_arr = []
						that.h_report_other_type.forEach(res=>{
							if(res == '关键页面访问'){
								sj_arr.push(1)
							}
							else if(res == '在线咨询'){
								sj_arr.push(2)
							}
							else if(res == '关键行为'){
								sj_arr.push(3)
							}
						})
						
						r_data.report_other_type = sj_arr
					}
				}
				// 这里不用传，后端不需要
				// else if(that.h_channel_name.indexOf('巨量') > -1 || that.h_channel_name.indexOf('百度') > -1 || that.h_channel_name.indexOf('微博') > -1){
				// 	r_data.report_type = that.h_report_type // 事件类型
				// }
				
				if(that.h_status){// 是否启用
					r_data.status = 1 // 启用
				}
				else {
					r_data.status = 0
				}
				// 选了注册后充值
				if(that.h_order_time_condition_type == 0){ 
					r_data.order_time_condition_n = that.h_order_time_condition_n // 注册后几小时内首次充值
				}
				
				// 是否批量
				if(that.h_type_pl == 1){ // 批量
					let h_data = []
					const h_channel = []
					that.selectedData.forEach(res=>{
						h_data.push(res.link_id)
						h_channel.push(res.channel)
					})
					
					r_data.channel = h_channel
					r_data.link_id = h_data
					
					that.$emit('hc-request',r_data)
					
				}
				else { // 单个设置
					let aaa = []
					aaa.push(that.h_id)
					r_data.link_id = aaa
					r_data.channel = that.h_channel
					that.$emit('hc-request',r_data)
					
				}
			},(reason)=>{ // promise状态-失败
				
			})
			
		},
		// 回传比例侧边栏关闭
		hcCloseDrawer(){
			
			this.hc_visible = false
			this.hc_button_loading = false
			
			this.hc_form_hint = ""
			// 充值状态
			this.h_report_money_limit = window.$InitialValues.report_money_limit, // 回传最低金额
			this.h_user_reg_time_condition = 1, // 注册时间
			this.h_order_time_condition_type = 1, // 充值时间
			this.h_order_time_condition_n = 24, // 注册后几小时内首次充值
			this.h_report_per =  100// 回传比例
			this.h_status = true
			this.h_name = ""
			this.h_id = ""
			this.h_type_pl = 0
			
			this.h_report_type = 1 // 事件类型
			this.h_report_all = 1, // 是否全量回传 0=否，1=是
			this.h_report_other_type = []
			
			// 自定义回传。之所以这里要重置是因为还有个批量按钮的入口
			this.h_report_per_type = 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			this.hCustomData = [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
				}
			],
			
			document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			setTimeout(()=>{
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			},300)
		},
		// 回传比例侧边栏的是否启用按钮
		hcDrawerSwitch(e){
			console.log(e);
			this.h_status = e
		},
		hcRadioA(e){ // 注册时间
			console.log(e.target.value);
			this.h_user_reg_time_condition = e.target.value
		},
		hcRadioB(e){ // 充值时间
			console.log(e.target.value);
			this.h_order_time_condition_type = e.target.value
		},
		// 回传比例的数字输入框
		hcNumber(e,type){
			console.log(e,type);
			if(type == 1){ // 回传最低金额(元)
				this.h_report_money_limit = e
			}
			else if(type == 2){ // 注册后几小时内首次充值
				this.h_order_time_condition_n = e
			}
			else if(type == 3){ // 回传比例
				this.h_report_per = e
			}
		},
		// 自定义回传序列开始
		hcRadioE(e){ // 设置方式 回传比率类型，1=老回传比率，2=自定义回传比率
			this.h_report_per_type = e.target.value
		},
		hcRadioS(e){ // 是否开启付费2
			this.h_is_supply_active_pay = e.target.value
		},
		hcCustomHandleA(indd){ // 下单回传序列
			let obj = {
				value: 0,
				id: 'a' + new Date().getTime()
			}
			this.hCustomData[indd].h_order_per.push(obj)
		},
		hcCustomHandleC(indd){ // 删除
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(this.hCustomData[indd].h_order_per.length -1 , 1)
		}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		hcCustomDelA(index,indd){ // 下单回传序列-删除操作
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(index,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}	
		},
		// 新增订单范围
		hcAddCustom(){
			let obj = {
				id: 'c' + new Date().getTime(),
				h_min_money: 0, // 金额区间最小金额
				h_max_money: 0, // 金额区间最大金额
				h_order_per: [{ // 下单回传比率数组
					id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
					value: 0
				}],
			}
			this.hCustomData.push(obj)
		},
		// 删除新增订单范围
		hcDelCustom(indd){
			if(this.hCustomData.length > 1){
				this.hCustomData.splice(indd,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		// 自定义回传部分结束
		
		hcRadioL(e){ // 事件类型
			this.h_report_type = e.target.value
		},
		hcRadioF(e){ // 是否全量回传 0=否，1=是
			this.h_report_all = e.target.value
		},
		hcChangeA(e){ // 补充事件类型
			// console.log(e);
			this.h_report_other_type = e
		},
		
		closeLoading(){
			this.hc_button_loading = false
		},
		plHcHandle(s_data){ // 批量
			this.selectedData = s_data
			this.h_type_pl = 1
			this.hc_visible = true
		},
	}
}
</script>

<style scoped>
.class-title {
	width: 115px;
}
</style>